import type { TurnMessage } from "../../hooks/useTurnMessages";
import { BotMessage } from "../BotMessage";
import { UserMessage } from "../UserMessage";

interface TurnMessagesProps {
  messages: readonly TurnMessage[];
}

export function TurnMessages({ messages }: TurnMessagesProps) {
  return (
    <>
      {messages.map((message) =>
        message.from === "user" ? (
          <UserMessage key={message.id} text={message.text} />
        ) : (
          <BotMessage
            key={message.id}
            lines={message.lines}
            isError={message.isError}
            isTyped={message.isTyped}
          />
        ),
      )}
    </>
  );
}
